module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['ui-dropdown', _vm.open ? 'open' : 'closed']
  }, [_vm._t("default", [_c('button', {
    staticClass: "ui-dropdown__button",
    on: {
      "click": function($event) {
        _vm.open = !_vm.open
      }
    }
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')])]), _vm._v(" "), (_vm.open) ? _c('div', {
    class: ['ui-dropdown__menu']
  }, [_c('ui-tab-list', {
    attrs: {
      "tabs": _vm.list,
      "callback": _vm.onClick
    }
  })], 1) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2565d974","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/universal/UiDropdown.vue
// module id = 434
// module chunks = 1